<template>
  <div class="card">
    <div class="card-body">
      <h4 class="title text-primary mb-0">{{ __("Top Uploaders") }}</h4>
      <div class="mt-4">
        <Spinner v-if="loading" spinner-type="grow" min-height="320px" />
        <template v-else-if="uploaders.length">
          <div
            v-for="(uploader, i) in uploaders"
            :key="i"
            class="d-flex justify-content-between align-items-center mb-3"
          >
            <div class="d-flex align-items-center gap-2">
              <a :href="`/profile/${uploader.user_name}`" target="_blank">
                <img
                  :src="asset_file_url(uploader.profile_picture)"
                  @error="image_load_error"
                  class="rounded-circle"
                  height="40"
                  alt="photo"
                />
              </a>
              <div>
                <a
                  :href="`/profile/${uploader.user_name}`"
                  target="_blank"
                  class="d-block text-primary"
                >
                  {{ locale_attr(uploader, "name_{lang}") || uploader.name_en }}
                </a>
                <small>{{ uploader.email }}</small>
              </div>
            </div>
            <div class="border rounded-circle p-2">
              {{ en_to_bn(uploader.contents_count) }}
            </div>
          </div>
        </template>
        <div
          v-else
          class="d-flex justify-content-center align-items-center"
          style="min-height: 320px"
        >
          {{ __("No data found") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Spinner from "../../components/Spinner";

export default {
  components: {
    Spinner,
  },

  data() {
    return {
      uploaders: [],
      loading: false,
    };
  },

  mounted() {
    this.observe_visibility(this.$el, () => this.fetchUploaders());
  },

  methods: {
    fetchUploaders() {
      this.loading = true;
      axios
        .get("/dashboard/top-uploaders")
        .then(({ data }) => (this.uploaders = data.uploaders))
        .catch(console.error)
        .finally(() => (this.loading = false));
    },
  },
};
</script>
